export const KNOWN_AUTHORITIES = ['signin.groundfloordelivery.com', 'signin.lastk.io'];
export const CACHE_LOCATION = 'localStorage';
export const SIGNALR_X_FUNCTIONS_KEY = 'lYzpF7EbNtHm7Ois3dPHnX-lkSLk6bQqqxaso0JdjInAAzFuApzRVg==';

// TODO: Implement pagination and remove
export const PAGINATION_FIXED_PAGE_SIZE = 200;
